import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  Input,
  FormFeedback,
  Col,
  Row,
  Alert,
} from "reactstrap";
import { has, isEmpty, get } from 'lodash'

import * as Yup from "yup";
import { useFormik } from "formik";

// Redux
import { useSelector, useDispatch } from "react-redux";

// Custom Utility Functions
import { dateGen } from 'utils/toolUtils';
import { fetchImage, uploadImg } from 'utils/imageUtils';

// Import Images
import placeholder from "assets/images/placeholders/placeholder_card.png"


const CreateModal = ({ createModal, toggle, qaPairs, onAddNewChatbot, url, selectedSelector, selectorDictionary }) => {

  const chatbots = useSelector(state => state.chatbots);
  useEffect(() => {
    console.log('chatbots', chatbots, has(chatbots, 'error'));
    if (has(chatbots, 'error.response')) {
      setErrorMessage(get(chatbots, 'error.response.data.message', '新增智能客服發生錯誤'));
    } else if (chatbots.chatbotAddSuccess) {
      setErrorMessage('');
      navigate('/chatbot-menu');
    }
  }, [chatbots]);
  const [errorMessage, setErrorMessage] = useState('');

  /*---- Initial Setup ----*/
  const dispatch = useDispatch();
  const navigate = useNavigate();
  /*---- Initial Setup Tail ----*/



  /*---- Form Validation ----*/

  const validation = useFormik({

    enableReinitialize: true,

    // Inital values of the form fields
    initialValues: {
      img: "placeholder.png",
      name: "",
      description: "",
      tags: [],
    },

    // validation rules using Yup
    validationSchema: Yup.object({
      name: Yup.string().required("請輸入智能客服名稱"),
      tags: Yup.array().of(Yup.string()).required("請輸入標籤").min(1, "至少需要一個標籤"),
    }),

    // gets called when the form is submitted
    onSubmit: (values) => {
      
      const newChatbot = {
        img: filename,
        cbName: values.name,
        cbDesc: (values.description || values.name),
        tags: values.tags,
        entries: qaPairs.map(q => ({'Source': q.question, 'Target': q.answer})), //[{'Source':'Q1', 'Target':'A1'}, {'Source':'Q2', 'Target':'A2'}],
        isChunk: false,
      };
      // console.log('submitting values:', newChatbot);
      dispatch(onAddNewChatbot(newChatbot));
      // toggle(); // Close the modal
      //navigate('/chatbot-menu');

    },

  });

  /*---- Form Validation Tail ----*/



  /*---- Uploading a new Chatbot Image ----*/

  // cb.img is the image name, cbImage is the image itself
  const [filename, setFilename] = useState(('還沒有選擇圖片喔'));
  const [newImageUrl, setNewImageUrl] = useState('');

  const handleImageChange = async(event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    if (file) {
      const date14string = await dateGen();
      const newfilename = date14string+'_'+file.name;
      setFilename(newfilename);
      const {newImageUrl:thisImage, uploadStatus} = await uploadImg(newfilename, file);
      setNewImageUrl(thisImage);
    }
  };

  /*---- Uploading a new Chatbot Image Tail ----*/



  return (
    <React.Fragment>


      {/* 智能客服編輯視窗 */}
      <Modal isOpen={createModal} toggle={toggle}>

        {/* 專案編輯視窗標題 */}
        <ModalHeader toggle={toggle} tag="h4">
          {`從問答集新增智能客服`}
        </ModalHeader>

        {/* 專案編輯視窗內容 */}
        <ModalBody>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>

                {/* url: https://ec.ltn.com.tw/article/paper/1636012 */} 
                {/* selectedSelector:{selectedSelector}: .content:nth-of-type(1) */} 
                {/* selectorDictionary[selectedSelector]}: 
                  彭博： 中國不須動武 鎖定高雄釀「斷氣」危機即可影響台灣 蘋果光再現！台積電飆908元新天價 
                  指數突破22000點再刷新高 財經 > 財經週報 〈財經週報-新創〉不再漏新創 經濟部將推白皮書 
                  2024/03/17 05:30 《中小企業白皮書》缺漏新創的篇章，
                  中企署允諾今年會啟動《新創事業白皮書》籌備工作。
                */} 

                {/* 智能客服名稱 */}
                <div className="mb-3">
                  <Label for="chatbotName" className="form-label">智能客服名稱</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name}
                    invalid={
                      validation.touched.name && validation.errors.name ? true : false
                    }
                  />
                  {/* Display error message */}
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                  ) : null}
                </div>


                {/* 智能客服頭貼 */}
                <div className="mb-3">
                  <Label for="chatbotImage" className="form-label">智能客服頭貼</Label>
                  <Input
                    id="img"
                    name="img"
                    type="file"
                    onChange={(event) => {
                      handleImageChange(event, validation.setFieldValue);
                    }}
                  />
                  <div style={{ display:"flex", justifyContent:"center", margin:"1rem 0rem" }}>
                    <img 
                      src={newImageUrl || placeholder} 
                      alt="Chatbot" 
                      style={{ 
                          width: '100px', 
                          height: '100px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                      }}
                    />
                  </div>
                </div>


                {/* 智能客服類型 */}
                <div className="mb-3">
                  <Label className="form-label">智能客服類型</Label>

                  <Input
                    name="tags"
                    id="tags"
                    type="select"
                    multiple
                    //className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.tags || ""}
                  >
                    <option value="">選擇智能客服類型:</option>
                    <option value="產品說明">產品說明</option>
                    <option value="產品銷售">產品銷售</option>
                    <option value="場館導覽">場館導覽</option>
                    <option value="文本問答">文本問答</option>
                    <option value="智能客服">智能客服</option>
                    <option value="其他">其他</option>
                  </Input>

                  {validation.touched.tags && validation.errors.tags ? (
                    <FormFeedback type="invalid">{validation.errors.tags}</FormFeedback>
                  ) : null}
                </div>

                
                {/* 智能客服描述 */}
                <div className="mb-3">
                  <Label className="form-label">智能客服描述</Label>
                  <Input
                    name="description"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.description || ""}
                    placeholder={validation.values.name || "輸入智能客服描述"}
                    invalid={
                      validation.touched.description && validation.errors.description ? true : false
                    }
                  />
                  {validation.touched.description && validation.errors.description ? (
                    <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                  ) : null}
                </div>


                {/* 智能客服知識 */}
                <div 
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <Label className="form-label">智能客服知識</Label>
                  {qaPairs.map((pair, index) => (
                    <Row key={index} className="qa-pair" style={{ padding: '1rem 0.5rem', marginBottom: '0rem' }}>
                      <Col sm="1" 
                        style={{ 
                          display:'flex', 
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <div style={{ fontWeight: 'bold' }}>{index + 1}.</div>
                      </Col>
                      <Col sm="11">
                        <div style={{ marginBottom: '0.2rem' }}>Q: {pair.question}</div>
                        <div>A: {pair.answer}</div>
                      </Col>
                    </Row>
                  ))}
                </div>


              </Col>
            </Row>

            {/* errorMessage */}
            <Alert color="danger" isOpen={!isEmpty(errorMessage)}>
              {errorMessage}
              <button
              onClick={() => setErrorMessage('')}
                type="button"
                className="btn-close btn-close-white me-2 m-auto float-end"
                data-bs-dismiss="alert"
                aria-label="Close"
              />
            </Alert>

            {/* 儲存變更按鈕 */}
            <Row>
              <Col style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '1rem 0rem 0.5rem 0rem',
              }}>
                <div className="text-end">
                  <button
                    type="submit"
                    className="btn btn-success save-user"
                  >
                    新增智能客服
                  </button>
                </div>
              </Col>
            </Row>

          </Form>

        </ModalBody>

      {/* ^專案編輯視窗 */}
      </Modal>
    </React.Fragment>
  );

};

export default CreateModal;
